import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const ArrowNoStem = ({ color = 'black', direction = 'down', translateX = 0, translateY = 0, style: overwriteStyles = {}, ...attr }) => {
  let _rotation = '0';
  switch (direction) {
    case 'up':
      _rotation = '180';
      break;
    case 'left':
      _rotation = '90';
      break;
    case 'right':
      _rotation = '-90';
      break;
    default:
      _rotation = '0';
  }
  return (
    <svg
      style={{ ...style, ...overwriteStyles }}
      {...attr}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      transform={`rotate(${_rotation}) translate(${translateX}, ${translateY})`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 7.58691L8.58692 15.1738L16.1738 7.58691" stroke={color} />
    </svg>
  );

};

export default ArrowNoStem;
